var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "flex center flex-row items-center justify-between w-100 mw5 mw6-ns"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "social-btn-bg mh0 mh3-ns bg-center flex flex-column items-center justify-center tc grow"
        },
        [
          _c(
            "a",
            {
              staticClass:
                "flex flex-row items-center justify-center pointer social-btn facebook",
              attrs: {
                title: "Facebook link",
                href: "https://www.facebook.com/themobrep/",
                target: "_blank"
              }
            },
            [
              _c("simple-svg", {
                attrs: {
                  filepath: "/assets/images/svg/icons/facebook.svg",
                  id: "social-icon-svg"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "social-btn-bg mh0 mh3-ns bg-center flex flex-column items-center justify-center tc grow"
        },
        [
          _c(
            "a",
            {
              staticClass:
                "flex flex-row items-center justify-center pointer social-btn instagram",
              attrs: {
                title: "Instagram link",
                href: "https://www.instagram.com/themobrep/",
                target: "_blank"
              }
            },
            [
              _c("simple-svg", {
                attrs: {
                  filepath: "/assets/images/svg/icons/instagram.svg",
                  id: "social-icon-svg"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "social-btn-bg mh0 mh3-ns bg-center flex flex-column items-center justify-center tc grow"
        },
        [
          _c(
            "a",
            {
              staticClass:
                "flex flex-row items-center justify-center pointer social-btn twitter",
              attrs: {
                title: "Twitter link",
                href: "https://twitter.com/MobRep_Chi",
                target: "_blank"
              }
            },
            [
              _c("simple-svg", {
                attrs: {
                  filepath: "/assets/images/svg/icons/twitter.svg",
                  id: "social-icon-svg"
                }
              })
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }